import { IconKey,IconDeviceLaptop } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconDeviceLaptop
};
//

const IT = {

    id: 'it',
    title: 'IT',
    type: 'group',
    display_id:'N',
    icon: icons.IconDeviceLaptop,
    children: [
        {
            id: 'it_dashboard',
            title: 'Dashboard',
            type: 'item',
            display_id:48,
            url: '/Department/IT',
            breadcrumbs: false
        },
    ]
}

export default IT;